module.exports = __webpack_public_path__ + "assets/img/coming-soon.1161dd61.png";